import { render, staticRenderFns } from "./ReleaseCallbackModal.vue?vue&type=template&id=485b03f8&"
import script from "./ReleaseCallbackModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseCallbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports